import { Language } from "../i18n/useLanguage";

const formatTime = (time: string, language: Language): string => {
  if (language === "fr") {
    return time; // Keep as 24-hour format for French
  }

  const [hour, minute] = time.split(":");
  let newHour = parseInt(hour, 10);
  let ampm = "am";

  if (newHour >= 12) {
    ampm = "pm";
  }
  if (newHour > 12) {
    newHour -= 12;
  }
  if (newHour === 0) {
    newHour = 12;
  }

  return `${newHour.toString().padStart(2, "0")}:${minute} ${ampm}`;
};

export const formatWorkingHours = (
  open: string,
  close: string,
  language: Language
): null | string => {
  if (!open || !close) {
    return null;
  }

  const openTime = formatTime(open, language);
  const closeTime = formatTime(close, language);

  return `${openTime} ${language === "fr" ? "à" : "to"} ${closeTime}`;
};
